/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SplitViewService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(url, filter) {
    const requestScreenData = {
      url: "api/" + url,
      top: "1",
      // filter: `Code eq '${code}'`,
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getItems(requestParams) {
    return await ApiService.oDataGet(requestParams);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async saveItem(url, payload) {
    return await ApiService.post('/api/' + url, payload);
  },

  async updateItem(url, code, payload) {
    return await ApiService.patch('/api/' + url, code, payload, "Guid");
  },

  async updateItemByCode(url, code, payload) {
    return await ApiService.patch('/api/' + url, code, payload, typeof code);
  },

  async updateItemByCodeWithType(url, code, payload,type) {
    return await ApiService.patch('/api/' + url, code, payload, type);
  },

  async updateItemByCompositeKey(url, keyParts, payload) {
    return await ApiService.patch('/api/' + url, keyParts, payload);
  },

  async getIsDefault(url) {

    const requestScreenData = {
      url: "api/" + url,
      top: "1",
      filter: `IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};

export { SplitViewService };
